import TextPlaceholder from "./TextPlaceholder";

/**
 * Props for the Caption component
 */
type CaptionProps = {
  /** The figure number to display (e.g., "1", "2a", "3.1") */
  number: string;
  /** The descriptive text explaining what the figure shows */
  description: string;
};

/**
 * A component that displays a figure caption with a number and description.
 * Typically used to label figures, charts, or other visual content in markdown.
 *
 */
function Caption({ number, description }: CaptionProps) {
  return (
    <span className="text-fg-muted mb-6 block break-before-avoid">
      <span className="tiny-mono-semibold uppercase mr-2">Figure {number}</span>
      <span className="tiny-normal"> {description}</span>
    </span>
  );
}

export default Caption;

/**
 * Placeholder component shown while caption content is loading
 */
export const CaptionPlaceholder = () => {
  return <TextPlaceholder width="80" />;
};

/**
 * Converts caption data to markdown format for plain text export
 *
 * @param props - Caption props containing number and description
 * @returns Formatted markdown string
 */
export const CaptionMarkdown = ({ number, description }: CaptionProps) => {
  return `**Figure ${number}:** ${description}`;
};
